// components/BuscadorClienteFactura/TextFieldPersonalizado.jsx
import React from 'react';
import {
  TextField,
  IconButton,
  Tooltip,
  CircularProgress,
  InputAdornment
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

const TextFieldPersonalizado = ({
  params,
  label,
  placeholder,
  size,
  error,
  helperText,
  cargando,
  inputValue,
  onToggleFiltros,
  onLimpiar,
  mostrarFiltros
}) => {
  return (
    <TextField
      {...params}
      label={label}
      placeholder={placeholder}
      size={size}
      error={error}
      helperText={helperText}
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <>
            <Tooltip title={mostrarFiltros ? "Ocultar filtros" : "Mostrar filtros"}>
              <IconButton
                size="small"
                onClick={onToggleFiltros}
                sx={{ mr: 0.5 }}
              >
                <FilterListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            {params.InputProps.startAdornment}
          </>
        ),
        endAdornment: (
          <>
            {cargando ? (
              <CircularProgress color="inherit" size={20} />
            ) 
              // <IconButton size="small" onClick={onLimpiar}>
              //   <ClearIcon />
              // </IconButton>
            : null}
            {params.InputProps.endAdornment}
          </>
        )
      }}
    />
  );
};

export default TextFieldPersonalizado;